// Logged-in app page: Clip packs (routes/ClipPacks.tsx). Keep keys in sync with pl/appClipPacks.ts.
export const appClipPacks = {
  head: {
    title: 'Clip packs',
    upload: 'Upload files',
  },
  state: {
    reviewed: 'reviewed',
    cutting: 'cutting',
    needsReview: 'to review',
  },
  card: {
    clipsWord_one: 'clip',
    clipsWord_few: 'clips',
    clipsWord_many: 'clips',
    clipsWord: 'clips',
    addFiles: 'Add files',
    openAria: 'Open the pack “{name}”',
    cuttingFiles_one: '{done} of {total} file',
    cuttingFiles_few: '{done} of {total} files',
    cuttingFiles_many: '{done} of {total} files',
    cuttingFiles: '{done} of {total} files',
    deleteFailed: 'Could not delete the pack.',
  },
  menu: {
    more: 'More actions: {name}',
    moveToCollection: 'Move to collection',
    merge: 'Merge with another pack',
    delete: 'Delete pack',
  },
  delete: {
    ask: 'Delete the pack “{name}”?',
    rowClips: 'Clips',
    cancel: 'Cancel',
  },
  sort: {
    label: 'Sort',
    newest: 'Newest',
    oldest: 'Oldest',
    alpha: 'Alphabetical',
  },
  upload: {
    nameLabel: 'Pack name',
    pick: 'Choose files',
    addMore: 'Add more',
    removeFile: 'Remove {name}',
    cost: 'Cost',
    have: 'You have',
    left: 'Left',
    missing: 'Missing',
    // The unit is inflected by the shared `tokenWord` (locales/plural.ts) rather
    // than a second key family: with two copies one of them always falls behind.
    cut: 'Cut · {cost}',
    cutPlain: 'Cut',
    cancel: 'Cancel',
    busyTitle: 'Uploading files',
    files: 'Files {done} of {total}',
    abort: 'Stop',
    failedTitle: 'Could not upload the files.',
    retry: 'Try again',
    // The price is the one number this window never guesses. Until the server
    // sends it, cutting is blocked and the reason reaches the screen reader.
    priceLoading: 'The price list has not loaded yet - wait or reload it.',
    priceRefresh: 'Reload prices',
  },
  // Not enough tokens (33-R3, artboard 03d): a table of figures and ONE action.
  // The subtraction sentence ("You have 3, you need 30. Missing 27.") went out
  // with principle 8 — the "Missing" row says it without a sentence.
  short: {
    title: 'Not enough tokens',
    topUp: 'Top up tokens',
  },
  toast: {
    uploaded: 'Files uploaded.',
    moved: 'Moved to the collection “{name}”.',
    movedNone: 'The pack has no collection now.',
    moveFailed: 'Could not move the pack.',
    merged: 'Packs merged.',
    mergeFailed: 'Could not merge the packs.',
    deleted: 'Pack deleted.',
  },
  empty: {
    title: 'No clip packs',
    collectionTitle: 'This collection is empty',
    showAll: 'Show all packs',
  },
  error: {
    title: 'Could not load your clip packs.',
  },
  denied: {
    actionOff: 'account suspended',
  },
}
